import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { SingleAssetPicker } from '../../../../../SingleAssetPicker'
import { MobileSingle } from '../../../TikTokVideo/displays/MobileSingle'
import { getPickerArgs } from '../../constants'
import { SlideProps } from '../../types'
import { styles } from './styles'

export type MobileSlideProps = SlideProps & {
  accountImage: AssetReference | null
  accountName: string
  content: string
  onContentChange: (val: string) => void
  onSoundChange: (val: string) => void
  sound: string
  truncate: boolean
}

export const MobileSlide: React.FC<MobileSlideProps> = ({
  accountImage,
  accountName,
  assets = [],
  content,
  index,
  isDragging,
  isPresenting,
  isSnapshot,
  modules,
  onContentChange,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  onSoundChange,
  readOnly,
  sound,
  truncate,
}) => {
  const photo = assets.length ? assets[0] : null
  const [isHovered, setIsHovered] = useState(false)
  const pickerArgs = getPickerArgs(index, modules.length)

  return (
    <div
      css={styles.getSlideStyles(Boolean(photo))}
      className={kuiperClassNames('tiktok tiktok-carousel-slide')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <MobileSingle
        accountImage={accountImage}
        assetSlot={
          photo ? undefined : (
            <SingleAssetPicker
              allowedUploadTypes={pickerArgs.allowMultiple}
              disableDrop={isDragging}
              onDragDrop={(e) => onDragDrop(e, pickerArgs)}
              onShowAssetPicker={() => onShowAssetPicker(pickerArgs)}
              readOnly={readOnly}
              style={styles.picker}
              uploadType={pickerArgs.uploadType}
            />
          )
        }
        content={content}
        isHovered={isHovered}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        onContentChange={onContentChange}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        onSoundChange={onSoundChange}
        readOnly={readOnly}
        sound={sound}
        truncate={truncate}
        username={accountName}
        video={photo}
      />
    </div>
  )
}
